import { ReactNode } from 'react';

import styles from '../../styles/layouts/main.module.css';

interface MainLayoutProps {
    children?: ReactNode;
}

function MainLayout({ children = null }: MainLayoutProps) {
    return (
        <div className={styles.container}>
            <div className={styles.inner}>
                <div className={styles.content}>{children}</div>
            </div>
        </div>
    );
}

export default MainLayout;
